import ToastService from "primevue/toastservice";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component(ToastService);
});
